"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'API Request',
    description: 'Send an API request to an external application.',
    requiresIntegration: true,
});
//# sourceMappingURL=custom-api-request.js.map